import { render, staticRenderFns } from "./bac-settings.vue?vue&type=template&id=64ec69a4&"
import script from "./bac-settings.vue?vue&type=script&lang=js&"
export * from "./bac-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports